import React from 'react';
import { Button, Input } from 'antd';

const InputGroup = Input.Group;

export default class Files extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleSearch = () => {
        
        document.getElementById(this.props.identifier).click();
    }
    
    render() {
        return (
            <div>
                <input type="file" id={this.props.identifier} onChange={this.props.onChange} hidden />
                <InputGroup compact>
                    <Input
                        style={{ width: `calc(100% - 120px)` }}
                        value={this.props.filename}
                        required={true}
                        readOnly
                    />
                    <Button
                        icon={this.props.icon}
                        style={{ width: '40px' }}
                        disabled={this.props.icon === 'loading' ? true : false}
                        onClick={this.handleSearch}
                    />
                    <Button
                        type="danger"
                        icon="delete"
                        style={{ width: '40px' }}
                        disabled={this.props.icon === 'loading' ? true : (this.props.filename ? false : true)}
                        onClick={this.props.onRemove}
                    />
                </InputGroup>
            </div>
        );
    }

}